function multipleSingleItemError(componentName, tagName) {
  const err = new Error();
  err.message = `There can only be one (1) \`${tagName}\`. Please restructure your app.`;
  err.name = `${componentName}:MULTIPLE_SINGLE_ITEM_ERROR`;
  throw err;
}
function noSlotAttributeError(componentName, tagName, slotName) {
  const err = new Error();
  err.message = `
  This element must have a \`slot\` attribute. Please add [slot=${slotName}] to your element
  example:
    <${tagName} slot="${slotName}">
      <!-- content here -->
    <${tagName}>
  `;
  err.name = `${componentName}:NO_SLOT_ATTRIBUTE_ERROR`;
  throw err;
}
function missingThemingPaletteError() {
  const err = new Error();
  err.message = `
  EpiComponents was unable to find theme palette values.
  Please make sure that you define values in your CSS for AT LEAST the following Custom Properties:
  --brandPrimary
  --brandAccent
  --brandWarn
  --brandSecondary
  `;
  err.name = `EpiComponents:MISSING_THEMING_PALETTE_VALUE_ERROR`;
  throw err;
}
const throwAriaLabelAttributesError = (componentName) => {
  const err = new Error();
  err.name = `${componentName}::NO_ARIA_LABELS_ERROR`;
  err.message = `
  The ${componentName} Component must have either an aria-label OR an
  aria-labelledby attribute to be accessible. Please add one
  of these attributes.
  `;
  throw err;
};

export { multipleSingleItemError as a, missingThemingPaletteError as m, noSlotAttributeError as n, throwAriaLabelAttributesError as t };
